import { useState, useEffect } from "react";
import {
    Phone,
    Building2,
    Briefcase,
    Wallet,
    IdCard,
    CheckCircle2,
    FileText,
    ClipboardCheck,
    KeyRound,
} from "lucide-react";
import MMCLenderHeader from "../login/MMCLendingHeader";
import MMCLendingFooter from "../login/MMCLendingFooter";
const NAV_LINKS = [
    { label: "Loan Products", href: "#" },
    { label: "Branches", href: "#" },
    { label: "Loan Officer Directory", href: "#" },
    { label: "Calculators", href: "#" },
];

const BORROWER_PROFILES = [
    {
        icon: Building2,
        title: "Real Estate Investors",
        description:
            "Qualify based on property cash flow with DSCR loans. Scale your portfolio without personal income docs.",
    },
    {
        icon: Briefcase,
        title: "Self-Employed Borrowers",
        description:
            "Your bank deposits tell the real story. Qualify on 12-24 months of statements, no tax returns.",
    },
    {
        icon: Wallet,
        title: "No Employment / Asset-Rich",
        description:
            "Retired or between jobs with assets? Asset-based loans let your wealth qualify you, no job required.",
    },
    {
        icon: IdCard,
        title: "ITIN Holders",
        description:
            "No Social Security number? You can still own a home with our ITIN loan program.",
    },
];

const PROCESS_STEPS = [
    {
        step: "01",
        icon: ClipboardCheck,
        title: "Get Pre-Qualified",
        description:
            "Tell us about your situation. We match you with the right loan program in minutes.",
    },
    {
        step: "02",
        icon: FileText,
        title: "Submit Documents",
        description:
            "No tax returns for most programs. Bank statements, asset statements, or property income docs.",
    },
    {
        step: "03",
        icon: CheckCircle2,
        title: "Receive Approval",
        description:
            "Fast underwriting with manual review. We understand complex income situations.",
    },
    {
        step: "04",
        icon: KeyRound,
        title: "Close & Fund",
        description:
            "Close in as few as 21 days. Walk away with keys to your new property.",
    },
];

const STATS = [
    { value: "10,000", suffix: "+", label: "Loans Funded" },
    { value: "40", suffix: "", label: "States Licensed | Non-QM Loans" },
    { value: "20", suffix: "+", label: "Years Experience" },
];

export default function SkyLogin() {
    const [selectedProfile, setSelectedProfile] = useState(null);
    // Dropdown state for each menu
    const [openDropdown, setOpenDropdown] = useState(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClick = (e) => {
            if (
                !e.target.closest('.menu-btn') &&
                !e.target.closest('.dropdown-menu')
            ) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);
    const handleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };
    return (
        <div className="login-page">
            <MMCLenderHeader />
            <div className="content col-xs-12">
                <div
                    className="content col-xs-12"
                    style={{
                        backgroundImage: "url('content/Images/mmc/SkyPORT_Background.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        //minHeight: "500px", // adjust as needed
                        position: "relative" // for any absolute positioned children
                    }}
                >
                </div>
            </div>
            <MMCLendingFooter />
        </div>
    );
}
